// ─────────────────────────────────────────────────────────────────────────────
// AccessDenied — shown in place of the tabs for roles without Settings access.
// The backend enforces this too; this is the UI half.
// ─────────────────────────────────────────────────────────────────────────────
import styles from "./AccessDenied.module.css";

export default function AccessDenied({ role }) {
  return (
    <div className={styles.wrap}>
      <span className={styles.icon}>🔒</span>
      <div className={styles.title}>Access Restricted</div>
      <div className={styles.sub}>
        Your role doesn't have access to Settings. Contact your administrator to request access.
      </div>
      <div className={styles.role}>Your role: <strong>{role}</strong></div>
    </div>
  );
}
